/* eslint-disable */
import React, { Component } from 'react'


import Svg, {
    Circle,
    Ellipse,
    G,
    LinearGradient,
    RadialGradient,
    Line,
    Path,
    Polygon,
    Polyline,
    Rect,
    Symbol,

    Use,
    Defs,
    Stop
} from 'react-native-svg';

{/* <svg xmlns="http://www.w3.org/2000/svg" width="19" height="18" viewBox="0 0 19 18">
    <g fill="#FFFFFF" fill-rule="evenodd" transform="translate(0 -1)">
        <rect width="23.053" height="3.69" x="-2" y="8" transform="rotate(45 9.526 9.845)" rx="1.845" />
        <rect width="23.053" height="3.69" x="-2" y="8" transform="rotate(135 9.526 9.845)" rx="1.845" />
    </g>
</svg> */}


export const SvgX = ({ size }) => {
    return (<Svg width={size} height={size} viewBox="0 0 19 18">
        <G fill="#ffffff" fillRule="evenodd" transform="translate(0 -1)">
            <Rect width="23.053" height="3.69" x="-2" y="8" transform="rotate(45 9.526 9.845)" rx="1.845" />
            <Rect width="23.053" height="3.69" x="-2" y="8" transform="rotate(135 9.526 9.845)" rx="1.845" />
        </G>
    </Svg>)
}

